import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import commonProps from "../props/commonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputSelect2',
  props: commonProps,
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const selectedOption = ref({ value: "", text: "" });


const emit = __emit;

const onInput = (event: Event) => {
  const target = event.target as HTMLSelectElement;

  selectedOption.value = {
    value: target.value,
    text: target.options[target.selectedIndex].text,
  };

  emit("update:modelValue", selectedOption.value);
};

const __returned__ = { selectedOption, emit, onInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})